module.exports = __webpack_public_path__ + "media/images/hamburger_menu-a91c7dd4a03971694b55a49c9cc50914.png";